module.exports = __webpack_public_path__ + "media/images/icons/diamond-blue-7b5a377a42eab193b67b9da82125307f.svg";